export type DocumentReclassifyStatus = "approved" | "rejected";

export interface DocumentCommentModel {
  id?: string;
  documentId?: string;
  content: string;
  createdAt?: string;
  createdBy?: string;
  createdByName?: string;
  actorDisplayName?: string;
  [key: string]: unknown;
}

export interface AddDocumentCommentRequest {
  content: string;
}

export interface ReclassifyDocumentRequest {
  new_status: DocumentReclassifyStatus;
}

export interface ReclassifyDocumentResponse {
  documentId?: string;
  status?: string;
  newStatus?: string;
  [key: string]: unknown;
}

export interface AuditTrailFieldChange {
  field: string;
  original: unknown;
  updated: unknown;
}

export interface AuditTrailAssignmentDetails {
  assigneeDisplayName?: string;
  previousAssigneeDisplayName?: string;
}

export type AuditTrailStatusChangeReason =
  "human_review_requested" | "thread_reopened_after_comment";

export interface AuditTrailStatusChangeDetails {
  fromStatus?: string;
  toStatus?: string;
  reason?: AuditTrailStatusChangeReason;
}

export interface AuditTrailAiAnalysisDetails {
  decision: string;
  fromStatus?: string;
  toStatus?: string;
  rejectionReason?: string;
}

export interface AuditTrailReportingDetails {
  targetType: string;
  targetId: string;
  reportedAt?: string;
}

export interface AuditTrailAttachmentDetails {
  id?: string;
  fileName?: string;
  sizeBytes?: number;
}

export interface DocumentAuditTrailDetails {
  fieldChanges?: AuditTrailFieldChange[];
  assignment?: AuditTrailAssignmentDetails;
  statusChange?: AuditTrailStatusChangeDetails;
  aiAnalysis?: AuditTrailAiAnalysisDetails;
  reporting?: AuditTrailReportingDetails;
  /** Saettes af CLE paa bilag-haendelser, saa de kan skelnes fra selve
   * kursusbeviset - som ellers deler action UPLOADED og DELETED med dem. */
  attachment?: AuditTrailAttachmentDetails;
}

export interface DocumentAuditTrailModel {
  id?: string;
  documentId?: string;
  action?: DocumentAuditTrailAction;
  actorId?: string;
  actorDisplayName?: string;
  createdAt?: string;
  comment?: string;
  details?: DocumentAuditTrailDetails;
}

export enum DocumentAuditTrailAction {
  APPROVED = "approved",
  REJECTED = "rejected",
  UPLOADED = "uploaded",
  DELETED = "deleted",
  EDITED = "edited",
  LINKED_TO_OBLIGATION = "linked_to_obligation",
  STATUS_CHANGED = "status_changed",
  ASSIGNED_TO_USER = "assigned_to_user",
  RESOLVED_BY_USER = "resolved_by_user",
  UNASSIGNED_BY_USER = "unassigned_by_user",
}

export const DocumentAuditTrailActionLabels: Record<
  DocumentAuditTrailAction,
  string
> = {
  [DocumentAuditTrailAction.APPROVED]: "Godkendt",
  [DocumentAuditTrailAction.REJECTED]: "Afvist",
  [DocumentAuditTrailAction.UPLOADED]: "Uploadet",
  [DocumentAuditTrailAction.DELETED]: "Slettet",
  [DocumentAuditTrailAction.EDITED]: "Redigeret",
  [DocumentAuditTrailAction.LINKED_TO_OBLIGATION]: "Indberettet",
  [DocumentAuditTrailAction.STATUS_CHANGED]: "Status ændret",
  [DocumentAuditTrailAction.ASSIGNED_TO_USER]: "Tildelt til bruger",
  [DocumentAuditTrailAction.RESOLVED_BY_USER]: "Løst af bruger",
  [DocumentAuditTrailAction.UNASSIGNED_BY_USER]: "Frigivet fra bruger",
};
